import styled from "styled-components";
import { mobileOnly } from "_/style/media";

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  box-sizing: border-box;
  ${mobileOnly` 
    flex-direction: column;
  `}
`;

export const MainArea = styled.div`
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;

  ${mobileOnly` 
    order: -1;
  `}
`;

export const NoCurrentOrgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const NoCurrentOrgMessage = styled.div`
  max-width: 600px;
  font-size: 1.4rem;
`;
